import type { ReactNode } from 'react';

export const symbol_hard_disk: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-80q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h520q24 0 42 18t18 42v680q0 24-18 42t-42 18H220Zm0-60h520v-680H220v680Zm130-104h260q12.75 0 21.38-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.38-8.5H350q-12.75 0-21.37 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.37 8.5Zm129.5-164q64.5 0 110-45.24T635-562q0-65-45-110.5T480-718q-65 0-110 45.5T325-562q0 65 45 109.5T479.5-408Zm.5-99q-23.37 0-39.19-15.81Q425-538.63 425-562q0-23.38 15.81-39.19Q456.63-617 480-617q23.38 0 39.19 15.81Q535-585.38 535-562q0 23.37-15.81 39.19Q503.38-507 480-507Zm0-55Z"
		/>
	</svg>
);
